import { BaseUser, VenueContactUser } from '~types';

export const normalizeName = (user?: BaseUser | null) => {
  if (user?.firstName || user?.lastName) {
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  }

  if (user?.username) {
    return user.username;
  }

  if (user?.email) {
    return user.email;
  }

  return 'N/A';
};

export const formatContactName = (contact?: VenueContactUser | null) =>
  `${contact?.firstName ?? ''} ${contact?.lastName ?? ''}`.trim() || '---';
